import { render, staticRenderFns } from "./SideMenuButton.vue?vue&type=template&id=78a0a598&scoped=true&"
import script from "./SideMenuButton.vue?vue&type=script&lang=js&"
export * from "./SideMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuButton.vue?vue&type=style&index=0&id=78a0a598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0a598",
  null
  
)

export default component.exports